import env from '@beam-australia/react-env';
import { MarketLanguage } from './types';


export const API_BASE_URL = env('API_BASE_URL');
export const HS_FORM_PORTAL = env('HS_FORM_PORTAL');
export const HS_FORM_REGION = env('HS_FORM_REGION');

export const ENABLE_SITE_UNDER_MAINTENANCE = env('ENABLE_SITE_UNDER_MAINTENANCE');

export const DEFAULT_LANGUAGE = 'en';

export const DEFAULT_TRANSLATION_MARKET = 'BE';

export const ROUTES = {
  home: '/',
  countrySelect: '/country-select',
  structureSelect: '/structure-select',
  productSelect: 'product-select',
  steel: '/steel',
  structuralElements: 'structural-elements',
  protectedSides: 'protected-sides',
  environment: 'environment',
  fireRating: 'fire-rating',
  concrete: '/concrete',
  timber: '/timber',
  results: 'results',
  productDetails: 'product-details',
  siteUnderMaintenance: 'site-under-maintenance',
};

export const STEEL_ROUTES = {
  structuralElements: `${ROUTES.steel}/${ROUTES.structuralElements}`,
  protectedSides: `${ROUTES.steel}/${ROUTES.protectedSides}`,
  environment: `${ROUTES.steel}/${ROUTES.environment}`,
  fireRating: `${ROUTES.steel}/${ROUTES.fireRating}`,
  results: `${ROUTES.steel}/${ROUTES.results}`,
  productDetails: `${ROUTES.steel}/${ROUTES.productDetails}`,
  productSelect: `${ROUTES.steel}/${ROUTES.productSelect}`,
};

export const CONCRETE_ROUTES = {
  structuralElements: `${ROUTES.concrete}/${ROUTES.structuralElements}`,
  environment: `${ROUTES.concrete}/${ROUTES.environment}`,
  fireRating: `${ROUTES.concrete}/${ROUTES.fireRating}`,
  results: `${ROUTES.concrete}/${ROUTES.results}`,
  productDetails: `${ROUTES.concrete}/${ROUTES.productDetails}`,
  productSelect: `${ROUTES.concrete}/${ROUTES.productSelect}`,
};

export const TIMBER_ROUTES = {
  productSelect: `${ROUTES.timber}/${ROUTES.productSelect}`,
};

export const isInIframe = window.self !== window.top;

export const contactLinksByCountry: { [key: string]: string } = {
  AR: 'https://www.promat.com/es-ar/construccion/contacto/formulario/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  AU: 'https://www.promat.com/en-au/construction/contact-us/get-in-touch/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  BR: 'https://www.promat.com/pt-br/construcao/contato/como-falar-conosco/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  BG: 'https://www.promat.com/bg-bg/stroitelstvo/kontakti/formulyar-za-kontakt/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  CL: 'https://www.promat.com/es-cl/construccion/contacto/promat-chile/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  CO: 'https://www.promat.com/es-co/construccion/contactanos/formulario/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  HR: 'https://www.promat.com/hr-hr/graditeljstvo/nase-znanje-iskustvo/tehnicka-podrska/zatrazite-tehnicku-podrsku/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  FI: 'https://muotolevy.fi/ota-yhteytta/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  FR: 'https://www.promat.com/fr-fr/construction/contact/formulaire-contact/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  HU: 'https://www.promat.com/hu-hu/epiteszet/tudaskozpont/technikai-tamogatas/kerjen-tamogatast/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  IT: 'https://www.promat.com/it-it/edilizia/contattaci/get-in-touch/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  NL: 'https://www.promat.com/nl-nl/bouw/contact/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  PE: 'https://www.promat.com/es-pe/construccion/contacto/formulario/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  PL: 'https://www.promat.com/pl-pl/budownictwo/kontakt/formularz-kontaktowy/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  RO: 'https://www.promat.com/ro-ro/constructii/contactati-ne/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  RS: 'https://www.promat.com/sr-latn-rs/gradevinarstvo/kontakt/obrazac-za-kontakt/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  SK: 'https://www.promat.com/sk-sk/stavba/kontaktujte-nas/kontaktny-formular/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  SI: 'https://www.promat.com/sl-si/gradbenistvo/stik-z-nami/obrazec/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  ES: 'https://www.promat.com/es-es/construccion/contacto/contacte-nosotros/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
};

export const countryMultiLangLinks: {
  [key: string]: string;
} = {
  'fr-BE':
    'https://www.promat.com/fr-be/construction/contactez-nous/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
  'nl-BE':
    'https://www.promat.com/nl-be/bouw/contact/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta',
};

export const DEFAULT_CONTACT_LINK =
  'https://www.promat.com/en/construction/contact-us/get-in-touch/?utm_source=website&utm_medium=website&utm_campaign=structural-protection-calculator&utm_content=spc-cta';

export const COUNTRY_NAME_AND_CODE_MAP: { [key: string]: string } = {
  'Argentina': 'AR',
  'Australia': 'AU',
  'Austria': 'AT',
  'Belgium': 'BE',
  'Brazil': 'BR',
  'Bulgaria': 'BG',
  'Chile': 'CL',
  'Colombia': 'CO',
  'Croatia': 'HR',
  'Czechia': 'CZ',
  'Denmark': 'DK',
  'Estonia': 'EE',
  'Finland': 'FI',
  'France': 'FR',
  'Germany': 'DE',
  'Greece': 'GR',
  'Hong Kong': 'HK',
  'Hungary': 'HU',
  'Italy': 'IT',
  'Lithuania': 'LT',
  'Latvia': 'LV',
  'Netherlands': 'NL',
  'Peru': 'PE',
  'Poland': 'PL',
  'Romania': 'RO',
  'Serbia': 'RS',
  'Slovakia': 'SK',
  'Slovenia': 'SI',
  'Spain': 'ES',
  'Sweden': 'SE',
  'United Kingdom': 'GB'
};

export const COUNTRY_LANGUAGE_MAP: { [key:string]: MarketLanguage[] } = {
  'AR' : [ { languageCode: 'es', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'AU' : [ { languageCode: 'en-AU', isPrimary: true, order: 1 } ],
  'AT' : [ { languageCode: 'de-AT', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'BE' : [ { languageCode: 'en', isPrimary: true, order: 1 }, { languageCode: 'fr', isPrimary: false, order: 2 }, { languageCode: 'nl', isPrimary: false, order: 3 } ],
  'BR' : [ { languageCode: 'en', isPrimary: true, order: 1 } ],
  'BG' : [ { languageCode: 'bg', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'CL' : [ { languageCode: 'es', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'CO' : [ { languageCode: 'es', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'HR' : [ { languageCode: 'hr', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'CZ' : [ { languageCode: 'cs', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'DK' : [ { languageCode: 'da', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'EE' : [ { languageCode: 'en', isPrimary: true, order: 1 } ],
  'FI' : [ { languageCode: 'fi', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'FR' : [ { languageCode: 'fr', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'DE' : [ { languageCode: 'de-DE', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'GR' : [ { languageCode: 'en', isPrimary: true, order: 1 } ],
  'HU' : [ { languageCode: 'hu', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'IT' : [ { languageCode: 'it', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'LT' : [ { languageCode: 'en', isPrimary: true, order: 1 } ],
  'LV' : [ { languageCode: 'en', isPrimary: true, order: 1 } ],
  'NL' : [ { languageCode: 'nl', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'PE' : [ { languageCode: 'es', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'PL' : [ { languageCode: 'pl', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'RO' : [ { languageCode: 'ro', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'RS' : [ { languageCode: 'sr-Latn', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'SK' : [ { languageCode: 'sk', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'SI' : [ { languageCode: 'sl', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'ES' : [ { languageCode: 'es', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'SE' : [ { languageCode: 'sv', isPrimary: true, order: 1 }, { languageCode: 'en', isPrimary: false, order: 2 } ],
  'GB' : [ { languageCode: 'en-GB', isPrimary: true, order: 1 } ]
};